export default __webpack_public_path__ + "14f53925d3390a9f8a6573b8e7ea0d85.png";